module.exports = __webpack_public_path__ + "static/media/bh.86725006.svg";